import { render, staticRenderFns } from "./QualityReportLayout.vue?vue&type=template&id=6a59aa0d&scoped=true&"
import script from "./QualityReportLayout.vue?vue&type=script&lang=js&"
export * from "./QualityReportLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a59aa0d",
  null
  
)

export default component.exports